import { type FC } from 'react'

import { type UserOrderResponseWithFlags } from '@redteclab/api/clients/bully'

import { useGetExperiment } from '../../experiments/hooks'
import { EXPERIMENT_NAME_HELP_CENTER_SELF_SERVICES } from '../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../experiments/model/EXPERIMENT_VARIATION'
import { useGlobalConfigContext } from '../../global-config'
import { OrderDetailsCard } from '../../order'
import { contactPageAccessorGetUrlForOrderCard } from '../contactPageAccessorGetUrlForOrderCard'

export const ContactPageOrderCardList: FC<{
  maxOrders: number
  orders: UserOrderResponseWithFlags[]
}> = ({ maxOrders, orders }) => {
  const config = useGlobalConfigContext()

  const orderQuestionExperimentEnabled =
    useGetExperiment(EXPERIMENT_NAME_HELP_CENTER_SELF_SERVICES).variant ===
    EXPERIMENT_VARIATION.V1

  const filteredOrders = orders.slice(0, maxOrders).filter(
    (
      order,
    ): order is UserOrderResponseWithFlags & {
      orderMasterData: { orderNumber: string } & NonNullable<
        typeof order.orderMasterData
      >
    } => {
      return (
        Boolean(order.orderMasterData) &&
        typeof order.orderMasterData?.orderNumber === 'string'
      )
    },
  )

  if (filteredOrders.length === 0) {
    return null
  }

  return (
    <div
      className="mt-4 flex w-full flex-col gap-4 tablet:mb-12 tablet:mt-0 tablet:grid tablet:grid-cols-3 tablet:gap-6"
      id="order-section-order-details"
    >
      {filteredOrders.map((order) => {
        if (!order.subOrders?.length || !order.subOrders[0].subOrderId) {
          return null
        }

        return (
          <OrderDetailsCard
            href={contactPageAccessorGetUrlForOrderCard(
              config,
              order,
              orderQuestionExperimentEnabled,
            )}
            key={order.orderMasterData.orderNumber}
            order={order}
          />
        )
      })}
    </div>
  )
}
